import WaitForIt from './WaitForIt';
export default WaitForIt;